import React, { useEffect } from "react";
import { Button, Col, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { Formik, Field, Form as FormikForm, ErrorMessage } from "formik";
import { LocationvalidationSchema } from "../../utils/Validations";
import GetAddressInfo from "../../hooks/GetAddressInfo";
import { useMutation } from "@tanstack/react-query";
import { putRequest } from "../../services/apiMethods";
import { radiusCover } from "../../utils/commanFiles";
import toast from "react-hot-toast";

const Location = ({ data }) => {
  const { addressData, getAddress } = GetAddressInfo(); // Ensure this hook works correctly

  const initialValues = {
    postCode: "",
    address: "",
    radiusCover: "",
    latitude: addressData?.latitude || 0,
    longitude: addressData?.longitude || 0,
  };

  const { mutate, isLoading: apiState } = useMutation({
    mutationFn: (data) => {
      const modifyData = {
        postCode: data?.postCode || "",
        address: data?.address || "",
        latitude: addressData?.latitude || 0,
        longitude: addressData?.longitude || 0,
        radiusCover: Number(data?.radiusCover) || "",
      }
      return putRequest(`/profile/edit`, modifyData);
    },
    onSuccess: (data) => {
      toast.success(`${data?.message}`, {
        iconTheme: {
            primary: '#337FE0',
            secondary: '#FFFAEE',
        },
    })
    },
    onError: (error) => {
      console.error("Error during API call:", error);
    },
  });

  const handleSubmit = (values) => {
    mutate(values);

  };

  const handleSearchClick = (postCode) => {
    if (postCode) {
      getAddress(postCode); // Updates the addressData state with new addresses
    }
  };


  useEffect(() => {
    if (data?.postCode) {
      getAddress(data?.postCode);  // Trigger the getAddress function with the initial postCode
    }
  }, [data?.postCode]); // Only re-run when postCode changes


  return (
    <div className="my-profile-box-contain">
      <div className="my-profile-box-form">
        <div className="h-100 m-0">
          <div className="form-box-title">
            <h4>Location</h4>
            <p>Where can your clients find you?</p>
          </div>
          <Formik
            initialValues={data || initialValues}
            enableReinitialize={true}
            validationSchema={LocationvalidationSchema}
            onSubmit={handleSubmit}
          >
            {({ setFieldValue, values }) => (
              <FormikForm className="cmn-form-set">
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Post Code</Form.Label>
                  <div className="input-w-button">
                    <Field
                      type="text"
                      name="postCode"
                      className="form-control"
                      placeholder="Type here"
                      value={values.postCode}
                      onChange={(e) => {
                        const upperCaseValue = e.target.value.toUpperCase();
                        setFieldValue("postCode", upperCaseValue);
                      }}
                    />
                    <Button
                      variant="primary"
                      className="modal-f-btn pop-cancel-btn"
                      onClick={() => handleSearchClick(values.postCode)}
                    >
                      Search
                    </Button>
                  </div>
                  <ErrorMessage
                    name="postCode"
                    component="div"
                    className="text-danger"
                  />
                </Form.Group>
                <Form.Group className="mb-3" controlId="formBasicPassword">
                  <Form.Label>Location Shown on Profile</Form.Label>
                  <Field as="select" name="address" className="form-select" value={values.address}>
                    <option value="">Select Address</option>
                    {addressData?.addresses?.map((item, index) => {
                      return (
                        <option
                          value={item?.formatted_address
                            ?.filter(item => item.trim() !== '')
                            .map(item => item.split(',').map(word => word.trim()).join(','))
                          }
                          key={index}
                        >
                          {item?.formatted_address
                            ?.filter((item) => item !== "")
                            .join(", ")}
                        </option>
                      );
                    })}
                  </Field>
                  <ErrorMessage
                    name="address"
                    component="div"
                    className="text-danger"
                  />
                </Form.Group>
                <Row>
                  <Col lg={6}>
                    <Form.Group className="mb-3" controlId="formradiusCover">
                      <Form.Label>Service Radius</Form.Label>
                      <Field
                        id="category"
                        as={Form.Select}
                        name="radiusCover"
                        aria-label="Default select example"
                      >
                        <option value="">Select Radius</option>
                        {radiusCover.map((item, i) => (
                          <option key={i} value={item.value}>{item.label}</option>
                        ))}
                      </Field>
                      <ErrorMessage
                        name="radiusCover"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <button className="theme-comm-btn" type="submit">
                  Save
                </button>
              </FormikForm>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default Location;
